import { render, staticRenderFns } from "./AssistTeacher.vue?vue&type=template&id=3c21197b&"
import script from "./AssistTeacher.vue?vue&type=script&lang=js&"
export * from "./AssistTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports